/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SwitchJobsRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {SwitchJobsResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const switchJobs = (request: SwitchJobsRequest, options?: CashRequestOptions) => post<SwitchJobsRequest, SwitchJobsResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/SwitchJobs", request, {...options, rejectOnError: true })